const config = {
  // config type 映射关系
  configType: {
    steps: { id: '1', desc: '业务阶段' },
    brands: { id: '2', desc: '品牌' },
    products: { id: '3', desc: '合作产品' },
  },
};

export default config;
